import getSplitedPath from '@/services/functions/getSplitedPath'
import { isNil } from 'lodash'
/**
 * @param {string} fieldName
 * @param {any} dataItem
 */
function getNestedValue (fieldName, dataItem) {
  if (!fieldName) {
    return dataItem
  }
  const path = getSplitedPath(fieldName)
  let data = dataItem
  for (const p of path) {
    if (isNil(data)) return undefined
    data = data[p]
  }  
  return data
}

export default getNestedValue
